import { RECEIVE_FEED, RECEIVE_FEEDS } from "../actions/feed";

const DEFAULT_STATE = {
  byId: {},
  allIds: [],
  loading: true
};

const feeds = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RECEIVE_FEED: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      const { progressLog, ...newFeed } = action.feed;
      delete newFeed.client;

      const progressIds = progressLog.map(progress => progress.id);
      // Intentionally using snake_case since the rest of the keys will be too
      newFeed.progress_ids = progressIds;

      const newId = newFeed.id;
      byId[newId] = newFeed;
      if (!allIds.includes(newId)) allIds.push(newId);

      return {
        byId,
        allIds,
        loading: false
      };
    }
    case RECEIVE_FEEDS: {
      const allIds = state.allIds.slice(0);
      const byId = { ...state.byId };

      action.feeds.forEach(feed => {
        const { progressLog, ...newFeed } = feed;
        delete newFeed.client;

        const progressIds = progressLog.map(progress => progress.id);
        // Intentionally using snake_case since the rest of the keys will be too
        newFeed.progress_ids = progressIds;

        const newId = newFeed.id;
        byId[newId] = newFeed;
        if (!allIds.includes(newId)) allIds.push(newId);
      });

      return {
        byId,
        allIds,
        loading: false
      };
    }
    default:
      return state;
  }
};

export default feeds;
